export const procurementOfferCorrectionFieldNames = [
  "Teklif fiyatı", "Toplam bedel", "Teslimat süresi", "Ödeme vadesi",
  "Ek maliyetler", "Tedarikçi", "Belgeler", "Tedarikçi veya teklif belgesi",
] as const;

export const procurementRequestCorrectionFieldNames = [
  "Ürün / ihtiyaç başlığı", "İhtiyaç açıklaması", "Kategori",
  "Miktar ve birim", "İhtiyaç tarihi", "Öncelik",
] as const;

export const procurementOfferCorrectionFields = new Set<string>(procurementOfferCorrectionFieldNames);
export const procurementRequestCorrectionFields = new Set<string>(procurementRequestCorrectionFieldNames);
export const procurementCorrectionFields = new Set<string>([
  ...procurementOfferCorrectionFieldNames,
  ...procurementRequestCorrectionFieldNames,
]);

export function correctionTypeForFields(fields: string[]) {
  const hasRequestField = fields.some((field) => procurementRequestCorrectionFields.has(field));
  const hasOfferField = fields.some((field) => procurementOfferCorrectionFields.has(field));
  if (hasRequestField && hasOfferField) {
    throw new Error("Talep bilgisi ve teklif koşulu düzeltmeleri ayrı gönderilmelidir.");
  }
  return hasRequestField ? "REQUEST_DETAILS" as const : "EXPERT_CORRECTION" as const;
}

export function toggleCorrectionField(fields: string[], field: string) {
  if (fields.includes(field)) return fields.filter((item) => item !== field);
  const isRequest = procurementRequestCorrectionFields.has(field);
  return [...fields.filter((item) => procurementRequestCorrectionFields.has(item) === isRequest), field];
}
